import { useEffect, useState } from 'react';
import { globalBus } from '../../streams/wsBus';

type Toast = { id: string; level: 'info' | 'warn' | 'error'; message: string };

export function Toasts({ ws }: { ws?: WebSocket | null }) {
  const [items, setItems] = useState<Toast[]>([]);

  useEffect(() => {
    const pushToast = (level: Toast['level'], message: string) => {
      const id = `${Date.now()}_${Math.random()}`;
      setItems(prev => [...prev, { id, level, message }]);
      setTimeout(() => {
        setItems(prev => prev.filter(item => item.id !== id));
      }, 4000);
    };

    const socketListener = (event: MessageEvent) => {
      try {
        const message = JSON.parse(String(event.data));
        if (message?.t === 'toast') {
          pushToast(message.level ?? 'info', message.msg ?? '');
        }
      } catch (error) {
        console.warn('[Toasts] Failed to parse toast message', error);
      }
    };

    const localListener = (event: Event) => {
      const custom = event as CustomEvent<{ level: Toast['level']; message: string }>;
      if (custom?.detail) {
        pushToast(custom.detail.level, custom.detail.message);
      }
    };

    let busUnsubscribe: (() => void) | undefined;

    if (ws) {
      ws.addEventListener('message', socketListener);
    } else {
      busUnsubscribe = globalBus.subscribe((message) => {
        if (message?.t === 'toast') {
          pushToast(message.level ?? 'info', message.msg ?? '');
        }
      });
    }
    if (typeof window !== 'undefined') {
      window.addEventListener('hivecore:toast', localListener as EventListener);
    }

    return () => {
      if (ws) {
        ws.removeEventListener('message', socketListener);
      } else if (busUnsubscribe) {
        busUnsubscribe();
      }
      if (typeof window !== 'undefined') {
        window.removeEventListener('hivecore:toast', localListener as EventListener);
      }
    };
  }, [ws]);

  return (
    <div className="toasts">
      {items.map(item => (
        <div key={item.id} className={`toast ${item.level}`}>
          {item.message}
        </div>
      ))}
    </div>
  );
}
